import React from 'react';
import { useShop } from '../context/ShopContext';
import { MessageCircle, Phone } from 'lucide-react';

export default function StickyContactBar() {
  const { storeSettings, marketingOfferData } = useShop();

  const phone = marketingOfferData?.phoneNumber || storeSettings?.storePhone || '+919810023456';
  const whatsapp = marketingOfferData?.whatsappNumber || storeSettings?.storePhone || '+919810023456';
  const cleanPhone = phone.replace(/[^0-9+]/g, '');
  const cleanWhatsapp = whatsapp.replace(/[^0-9]/g, '');

  const handleWhatsApp = () => {
    const text = encodeURIComponent("Namaste M.L. Jewellers! I would like to inquire about today's live Gold & Silver rates and exclusive jewellery designs.");
    window.open(`https://wa.me/${cleanWhatsapp}?text=${text}`, '_blank');
  };

  const handleCall = () => {
    window.location.href = `tel:${cleanPhone}`;
  };

  return (
    <>
      {/* Floating Desktop & Tablet Buttons */}
      <div 
        className="sticky-contact-floating-buttons"
        style={{
          position: 'fixed',
          bottom: '24px',
          right: '24px',
          display: 'flex',
          flexDirection: 'column',
          gap: '12px',
          zIndex: 890
        }}
      >
        {/* Sticky Call Button */}
        <button
          onClick={handleCall}
          aria-label="Call Showroom"
          title="Call Showroom Desk"
          style={{
            width: '50px',
            height: '50px',
            borderRadius: '50%',
            background: 'linear-gradient(135deg, #1e40af 0%, #2563eb 100%)',
            color: '#ffffff',
            border: 'none',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            boxShadow: '0 6px 16px rgba(37, 99, 235, 0.4)',
            cursor: 'pointer',
            transition: 'transform 0.2s ease, box-shadow 0.2s ease'
          }}
          onMouseEnter={(e) => { e.currentTarget.style.transform = 'scale(1.08)'; }}
          onMouseLeave={(e) => { e.currentTarget.style.transform = 'scale(1)'; }}
        >
          <Phone size={22} />
        </button>

        {/* Sticky WhatsApp Button */}
        <button
          onClick={handleWhatsApp}
          aria-label="Chat on WhatsApp"
          title="Chat with Jewellery Expert on WhatsApp"
          style={{
            width: '54px',
            height: '54px',
            borderRadius: '50%',
            background: 'linear-gradient(135deg, #25D366 0%, #128C7E 100%)',
            color: '#ffffff',
            border: 'none',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            boxShadow: '0 6px 20px rgba(37, 211, 102, 0.45)',
            cursor: 'pointer',
            transition: 'transform 0.2s ease, box-shadow 0.2s ease',
            position: 'relative'
          }}
          onMouseEnter={(e) => { e.currentTarget.style.transform = 'scale(1.08)'; }}
          onMouseLeave={(e) => { e.currentTarget.style.transform = 'scale(1)'; }}
        >
          <MessageCircle size={26} />
          {/* Pulsing online badge */}
          <span style={{
            position: 'absolute',
            top: 2,
            right: 2,
            width: '12px',
            height: '12px',
            borderRadius: '50%',
            background: '#ffffff',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}>
            <span style={{
              width: '8px',
              height: '8px',
              borderRadius: '50%',
              background: '#22c55e'
            }} />
          </span>
        </button>
      </div>

      <style>{`
        @media (max-width: 640px) {
          .sticky-contact-floating-buttons {
            bottom: 74px !important; /* Positioned above mobile bottom bar */
            right: 14px !important;
            gap: 10px !important;
          }
          .sticky-contact-floating-buttons button {
            width: 46px !important;
            height: 46px !important;
          }
        }
      `}</style>
    </>
  );
}
